export default {
  data() {
    return {
      // eslint-disable-next-line
      docRevTypeOptions: [
        "AO",
        "BC",
        "BE",
        "BP",
        "PR"
      ],
      // eslint-disable-next-line
      docRevSecurityOptions: [
        "S1",
        "S2",
        "S3",
        "S4",
        "S5"
      ],
      // eslint-disable-next-line
      docRevStatusOptions: [
        "U",
        "D",
        "R",
        "A",
        "C",
        "S",
        "T",
        "P"
      ]
    };
  }
};
